// extracted by mini-css-extract-plugin
export default {"zoomModal":"r3-z","image":"s3-z","button":"t3-z","isOverlayShown":"u3-z"};